import store from '@/store'
import router from '@/router'
import jwtUtil from '@/utils/jwtUtil'

let expiryTimer = null

// Log out and go to the login page, coming back to the current page after signing in again
export function endSession() {
    clearTimeout(expiryTimer)
    store.dispatch('logout')
    const current = router.currentRoute
    if (current.name === 'Login') {
        return
    }
    const query = { expired: '1' }
    if (current.fullPath && current.fullPath !== '/') {
        query.redirect = current.fullPath
    }
    router.push({ path: '/login', query }).catch(() => {})
}

function checkSession() {
    const token = store.getters.getToken
    if (token && jwtUtil.isJwtExpired(token)) {
        endSession()
    }
}

function scheduleExpiry(token) {
    clearTimeout(expiryTimer)
    if (!token) {
        return
    }
    const expiresAt = jwtUtil.expiresAt(token)
    if (!expiresAt) {
        return
    }
    const delay = expiresAt * 1000 - Date.now()
    if (delay <= 0) {
        endSession()
        return
    }
    // setTimeout cannot wait longer than ~24.8 days
    expiryTimer = setTimeout(checkSession, Math.min(delay + 1000, 2147483000))
}

// Without this an idle page stayed "logged in" after the token expired, until the next click
export function startSessionWatch() {
    store.watch((state, getters) => getters.getToken, scheduleExpiry, { immediate: true })

    // timers do not run while a laptop sleeps, so check again when the tab comes back
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
            checkSession()
        }
    })
    window.addEventListener('focus', checkSession)

    // logging out in another tab ends the session here too
    window.addEventListener('storage', event => {
        if (event.key === 'api-token' && !event.newValue && store.getters.getToken) {
            endSession()
        }
    })
}
